import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';
import { withVerification } from '../VerificationPopup/withVerification';
import s from './UploadDropzone.scss';
const enhance = compose(withVerification, withTranslation());
class UploadDropzone extends React.Component {
    componentDidMount() {
        document.addEventListener('dragenter', this.onDragEnterLeave, true);
        document.addEventListener('dragleave', this.onDragEnterLeave, true);
        document.addEventListener('drop', this.onDragEnterLeave, true);
    }
    componentWillUnmount() {
        document.removeEventListener('dragenter', this.onDragEnterLeave);
        document.removeEventListener('dragleave', this.onDragEnterLeave);
        document.removeEventListener('drop', this.onDragEnterLeave);
    }
    render() {
        const { className , acceptedFileTypes , t  } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], this.state.dragInProgress && s['root-active'])
        }, /*#__PURE__*/ React.createElement(Dropzone, {
            accept: acceptedFileTypes && acceptedFileTypes.join(),
            onDrop: this.onFileDrop,
            noClick: true
        }, (_param)=>{
            var { getRootProps , getInputProps , isDragActive , isDragReject , acceptedFiles , fileRejections , draggedFiles  } = _param, props = _object_without_properties(_param, [
                "getRootProps",
                "getInputProps",
                "isDragActive",
                "isDragReject",
                "acceptedFiles",
                "fileRejections",
                "draggedFiles"
            ]);
            // We do a special check to avoid getting a "non-accepted" state when dragging a file over
            // a dropzone that hasn't been rendered yet but will be on drag (e.g. LoadableDaEditorWrapper)
            const isDragAccept = props.isDragAccept || draggedFiles.length > 0 && acceptedFiles.length === 0 && fileRejections.length === 0;
            return /*#__PURE__*/ React.createElement("div", _extends({}, getRootProps(), {
                className: classnames(s['dropzone'], isDragActive && s['dropzone-active'], isDragAccept && s['dropzone-accept'], isDragReject && s['dropzone-reject'], className)
            }), /*#__PURE__*/ React.createElement("input", _extends({}, getInputProps())), /*#__PURE__*/ React.createElement("p", null, isDragActive && t('mediapopup.upload.dropzone.accept'), isDragReject && t('mediapopup.upload.dropzone.reject')));
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            dragInProgress: false
        };
        this.dragCount = 0;
        this.onFileDrop = (acceptedFiles, rejectedFiles)=>{
            const { uploadFile , isVerificationNeeded , pushVerificationPopup  } = this.props;
            const file = acceptedFiles[0];
            if (!file) {
                return;
            }
            if (isVerificationNeeded) {
                pushVerificationPopup('submit');
                return;
            }
            uploadFile(file);
        };
        this.onDragEnterLeave = (e)=>{
            e.preventDefault();
            switch(e.type){
                case 'dragenter':
                    this.dragCount++;
                    break;
                case 'dragleave':
                    this.dragCount--;
                    break;
                case 'drop':
                    this.dragCount = 0;
                    break;
                default:
            }
            this.setState({
                dragInProgress: this.dragCount === 1
            });
        };
    }
}
export default enhance(UploadDropzone);
